import { GameState } from '../core/GameState.js';
import unlocksData from '../data/unlocks.json';

/**
 * HTML/CSS panel for the meta-progression unlock tree.
 * Accessible from the main menu.
 */
export class UnlockTreePanel {
  constructor(parentEl) {
    this.parentEl = parentEl;
    this.el = null;
    this.isOpen = false;
    this._create();
  }

  _create() {
    this.el = document.createElement('div');
    this.el.className = 'unlock-tree-panel';
    this.el.innerHTML = `
      <div class="unlock-tree-header">
        <h2>Crypt Upgrades</h2>
        <div class="unlock-tokens">Crypt Tokens: <span id="unlock-token-count">0</span></div>
      </div>
      <div class="unlock-tree-grid" id="unlock-tree-grid"></div>
      <button class="unlock-tree-close" id="unlock-tree-close">Close</button>
    `;
    this.el.style.display = 'none';
    this.parentEl.appendChild(this.el);

    // Style
    const style = document.createElement('style');
    style.textContent = `
      .unlock-tree-panel {
        position: absolute; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0,0,0,0.92);
        display: flex; flex-direction: column; align-items: center; justify-content: center;
        z-index: 200; font-family: monospace; color: #ccc;
      }
      .unlock-tree-header { text-align: center; margin-bottom: 12px; }
      .unlock-tree-header h2 { color: #ffcc44; font-size: 14px; margin: 0 0 4px 0; }
      .unlock-tokens { font-size: 11px; color: #ffdd88; }
      .unlock-tree-grid {
        display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px;
        max-width: 420px; width: 90%;
      }
      .unlock-category {
        background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.15);
        padding: 8px; border-radius: 3px; text-align: center; cursor: default;
      }
      .unlock-category:hover { border-color: rgba(255,255,255,0.3); }
      .unlock-cat-name { font-size: 11px; font-weight: bold; margin-bottom: 4px; }
      .unlock-cat-tier { font-size: 9px; color: #888; margin-bottom: 4px; }
      .unlock-cat-next { font-size: 9px; color: #aaa; margin-bottom: 6px; }
      .unlock-buy-btn {
        background: #44aa44; color: #fff; border: none; padding: 3px 8px;
        font-family: monospace; font-size: 9px; cursor: pointer; border-radius: 2px;
      }
      .unlock-buy-btn:hover { background: #55cc55; }
      .unlock-buy-btn:disabled { background: #555; cursor: default; color: #888; }
      .unlock-maxed { font-size: 9px; color: #ffcc44; }
      .unlock-tree-close {
        margin-top: 12px; background: #aa4444; color: #fff; border: none;
        padding: 4px 16px; font-family: monospace; font-size: 11px; cursor: pointer;
        border-radius: 2px;
      }
      .unlock-tree-close:hover { background: #cc5555; }
    `;
    this.parentEl.appendChild(style);

    document.getElementById('unlock-tree-close').addEventListener('click', () => this.close());
  }

  open() {
    this.isOpen = true;
    this.el.style.display = 'flex';
    this._refresh();
  }

  close() {
    this.isOpen = false;
    this.el.style.display = 'none';
  }

  _refresh() {
    document.getElementById('unlock-token-count').textContent = GameState.cryptTokens;
    const grid = document.getElementById('unlock-tree-grid');
    grid.innerHTML = '';

    for (const [catId, cat] of Object.entries(unlocksData.categories)) {
      const tier = GameState.getUnlockTier(catId);
      const maxTier = cat.tiers.length;
      const isMaxed = tier >= maxTier;
      const nextTier = isMaxed ? null : cat.tiers[tier];
      const colorHex = '#' + parseInt(cat.color, 16).toString(16).padStart(6, '0');

      const card = document.createElement('div');
      card.className = 'unlock-category';
      card.innerHTML = `
        <div class="unlock-cat-name" style="color:${colorHex}">${cat.name}</div>
        <div class="unlock-cat-tier">Tier ${tier}/${maxTier}</div>
        ${isMaxed
          ? '<div class="unlock-maxed">MAXED</div>'
          : `<div class="unlock-cat-next">${nextTier.label}</div>
             <button class="unlock-buy-btn" data-cat="${catId}" data-cost="${nextTier.cost}"
               ${GameState.cryptTokens < nextTier.cost ? 'disabled' : ''}>
               Buy (${nextTier.cost} tokens)
             </button>`
        }
      `;
      grid.appendChild(card);
    }

    // Wire buy buttons
    grid.querySelectorAll('.unlock-buy-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const catId = btn.dataset.cat;
        const cost = parseInt(btn.dataset.cost);
        if (GameState.purchaseUnlock(catId, cost)) {
          this._refresh();
        }
      });
    });
  }

  destroy() {
    if (this.el && this.el.parentElement) {
      this.el.parentElement.removeChild(this.el);
    }
  }
}
